import {ContractAddress, Reward, TDeposit, TDepositForServer, TRewardForServer} from "../api/contract";

export function formatDepositsToDepositsForServer(deposits: TDeposit[], address: ContractAddress, maxIndex: number): TDepositForServer[] {

    // const indexes: number[] = indexesForRewards.map(index => Number(index))

    return deposits.map((deposit): TDepositForServer => ({
        accumulator: String(deposit.accumulator),
        depositedAmount: String(deposit.depositedAmount),
        lastRewardDeposit: String(deposit.lastRewardDeposit),
        lockEnds: String(deposit.lockEnds),
        weight: String(deposit.weight),
        reward: String(deposit.reward),
        rewards: formatRewardsToRewardsForServer(deposit.rewards.slice(0, maxIndex)),
        status: 'active',
        index: String(deposit.index),
        wallet: address
    }))
}

export function formatDepositsForServerToDeposits(deposits: TDepositForServer[]): TDeposit[] {
    return deposits.map((deposit): TDeposit => ({
        accumulator: Number(deposit.accumulator),
        depositedAmount: Number(deposit.depositedAmount),
        lastRewardDeposit: Number(deposit.lastRewardDeposit),
        lockEnds: Number(deposit.lockEnds),
        weight: Number(deposit.weight),
        reward: Number(deposit.reward),
        rewards: formatRewardsForServerToRewards(deposit.rewards),
        status: 'active',
        index: BigInt(deposit.index),
    }))
}


export function formatRewardsToRewardsForServer(rewards: Reward[]): TRewardForServer[] {
    return rewards.map((reward): TRewardForServer => ({
        amount: String(reward.amount),
        symbol: String(reward.symbol),
        imgUri: String(reward.imgUri),
    }))
}

export function formatRewardsForServerToRewards(rewards: TRewardForServer[]): Reward[] {
    return rewards.map((reward): Reward => ({
        amount: Number(reward.amount),
        symbol: String(reward.symbol),
        imgUri: String(reward.imgUri),
    }))
}